var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuscles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4575 15.1918L15 6.5L12.5723 7.71386C12.2234 7.88829 11.805 7.84396 11.5004 7.6003L9.95816 6.36652C9.67527 6.14021 9.5369 5.7786 9.59646 5.42126L9.86073 3.8356C9.9411 3.35341 10.3583 3 10.8471 3H16.2792C16.7097 3 17.0918 3.27543 17.2279 3.68377L21.3998 16.1995C21.7767 16.701 22 17.3244 22 18C22 19.6569 20.6569 21 19 21H7C4.23858 21 2 18.7614 2 16C2 13.2386 4.23858 11 7 11C8.8873 11 10.5304 12.0457 11.3815 13.5892C11.4744 13.7578 11.6023 13.905 11.772 13.9958C12.3236 14.291 13.7166 14.9562 15.4575 15.1918Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuscles);
export default __webpack_public_path__ + "static/media/muscles.381fb16288b97034c2622051cc5d2c7b.svg";
export { ForwardRef as ReactComponent };